import { useState } from 'react'

export default function AccountForm({ account, providerConfigs, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: account?.Name || '',
    DefaultFromEmail: account?.DefaultFromEmail || '',
    DefaultFromName: account?.DefaultFromName || '',
    EmailProviderConfigId: account?.EmailProviderConfigId || '',
    IsDeleted: false
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      EmailProviderConfigId: formData.EmailProviderConfigId || null
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Account Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="Name"
          value={formData.Name}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., Marketing Emails"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Default From Email
          </label>
          <input
            type="email"
            name="DefaultFromEmail"
            value={formData.DefaultFromEmail}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="no-reply@example.com"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Used when sender email not specified
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Default From Name
          </label>
          <input
            type="text"
            name="DefaultFromName"
            value={formData.DefaultFromName}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="Support Team"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Email Provider Configuration
        </label>
        <select
          name="EmailProviderConfigId"
          value={formData.EmailProviderConfigId}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">-- Select Provider Config --</option>
          {providerConfigs?.map((config) => (
            <option key={config.EmailProviderConfigId} value={config.EmailProviderConfigId}>
              {config.Name}
            </option>
          ))}
        </select>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          SendGrid or other email provider settings
        </p>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600 disabled:opacity-50"
        >
          {loading ? 'Saving...' : account ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  )
}
